import React, { useMemo } from 'react';
import OrganizationAnalyticsBarChart from './OrganizationAnalyticsBarChart';
import { getDefaultTooltipFormatterWithTotal, mapIdsToLabels } from './chartUtils';

const OrganizationInfluencerNewUsersByInfluencerChart = ({ data, influencerLabelMap, pending }) => {
  const { categories, series } = useMemo(
    () => ({
      categories: mapIdsToLabels(data?.influencerIds, influencerLabelMap),
      series: [
        { name: 'Spenders', data: data?.spenders || [] },
        { name: 'Non-Spenders', data: data?.nonSpenders || [] },
      ],
    }),
    [data, influencerLabelMap],
  );
  const tooltipFormatter = useMemo(() => getDefaultTooltipFormatterWithTotal('number'), []);

  return (
    <OrganizationAnalyticsBarChart
      title="New Users By Creator"
      subtitle="Spenders vs non-spenders breakdown for the selected creators."
      categories={categories}
      series={series}
      pending={pending}
      emptyText="Select creators to load new users."
      stacked
      valueType="number"
      tooltipFormatter={tooltipFormatter}
    />
  );
};

export default OrganizationInfluencerNewUsersByInfluencerChart;
